import styled from 'styled-components';

export const Header = styled.header`
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: ${({ theme }) => theme.colors.primary};
  background: ${({ theme }) => theme.colors.greyBackground};
  padding: 5px 10px;
  border-bottom: 1px solid ${({ theme }) => theme.colors.border};

  div {
    display: flex;
    align-items: center;

    h1 {
      font-size: 16px;
      margin-left: 10px;
    }
  }

  aside {
    display: flex;
    align-items: center;

    svg {
      font-size: 20px;
    }

    button {
      background: transparent;
      border: none;
      transition: opacity 0.2s;

      &:hover {
        opacity: 0.7;
      }

      & + button {
        margin-left: 10px;
      }
    }

    a {
      margin-left: 10px;
      transition: opacity 0.2s;

      &:hover {
        opacity: 0.7;
      }
    }
  }
`;

export const Content = styled.main`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  flex: 1;
  justify-content: space-around;
  align-items: center;

  height: calc(100% - 30px);
`;

export const Icon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  height: 80px;
  width: 80px;
  border: 1px solid #ccc;
  background: ${({ theme }) => theme.colors.greyBackground};
  border-radius: 10px;

  margin: 16px;

  font-size: 1.5rem;

  transition: background 0.2s;

  &:hover {
    background-color: #ccc;
  }
`;
